import React from 'react';
import { LockIcon, ZapIcon, CheckCircleIcon } from 'lucide-react';
export function TrustBadges() {
  return <div className="flex justify-center" data-id="element-271">
      <div className="bg-[#1B3022] rounded-2xl px-6 py-3 inline-flex flex-col sm:flex-row items-center gap-3 sm:gap-8" data-id="element-272">
        <div className="flex items-center gap-2" data-id="element-273">
          <LockIcon className="w-4 h-4 text-[#e8943a]" data-id="element-274" />
          <span className="text-sm font-medium text-white/90" data-id="element-275">
            Compra 100% segura
          </span>
        </div>
        <div className="flex items-center gap-2" data-id="element-276">
          <ZapIcon className="w-4 h-4 text-[#e8943a]" data-id="element-277" />
          <span className="text-sm font-medium text-white/90" data-id="element-278">
            Acceso inmediato al PDF
          </span>
        </div>
        <div className="flex items-center gap-2" data-id="element-279">
          <CheckCircleIcon className="w-4 h-4 text-[#22c55e]" data-id="element-280" />
          <span className="text-sm font-medium text-white/90" data-id="element-281">
            Garantía de 7 días
          </span>
        </div>
      </div>
    </div>;
}